export const TEXT_ANSWER_PAIRS = "PairAnswerVariantTextDto";
export const IMAGE_FROM_BANK_ANSWER_PAIRS = "PairAnswerVariantImageBankDto";
export const IMAGE_FROM_UPLOAD_ANSWER_PAIRS = "PairAnswerVariantImageQuestionDto";
export const FORMULA_ANSWER_PAIRS = "PairAnswerVariantFormulaDto";
